(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-eurocomach"]) return;
  try {
    
  (() => {
    const hashString = (value) => {
      let hash = 0;
      for (let i = 0; i < value.length; i += 1) {
        hash = (hash << 5) - hash + value.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash);
    };

    const randomizeFeaturedProducts = () => {
      const collectionGroups = document.querySelectorAll('.eurocomach-collection__layout');
      const dayKey = new Date().toISOString().slice(0, 10);

      collectionGroups.forEach((groupLayout, groupIndex) => {
        const featuredContainer = groupLayout.querySelector('.eurocomach-collection__featured');
        const secondaryGrid = groupLayout.querySelector('.eurocomach-collection__grid');

        if (!featuredContainer || !secondaryGrid) return;

        const featuredCard = featuredContainer.querySelector('.eurocomach-collection__card');
        const secondaryItems = Array.from(secondaryGrid.querySelectorAll(':scope > .eurocomach-collection__item'));

        if (!featuredCard || secondaryItems.length === 0) return;

        const seedSource = `${dayKey}-${window.location.pathname}-${groupIndex}`;
        const featuredIndex = hashString(seedSource) % (secondaryItems.length + 1);
        if (featuredIndex === 0) return;

        const selectedItem = secondaryItems[featuredIndex - 1];
        const selectedCard = selectedItem.querySelector('.eurocomach-collection__card');
        if (!selectedCard) return;

        selectedItem.replaceChildren(featuredCard);
        featuredContainer.replaceChildren(selectedCard);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', randomizeFeaturedProducts, { once: true });
    } else {
      randomizeFeaturedProducts();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-request-form"] && !Shopify.designMode) return;
  try {
    
  // Serviceanmodning → app-proxy. Konfiguration læses fra data-attributter, så
  // dette script forbliver statisk (theme-check: StaticStylesheetAndJavascriptTags).
  // Medarbejder-slider: ét kort ad gangen, som ansatte-slideren. Egne
  // klassenavne og egen init, så de to ikke træder hinanden over tæerne.
  (function () {
    function initSlider(slider) {
      if (slider.dataset.bound === '1') return;
      slider.dataset.bound = '1';

      var track = slider.querySelector('[data-employee-track]');
      var kort = track ? track.children : [];
      var antal = kort.length;
      if (!track || antal < 2) return;

      var boks = slider.closest('.service-request__employee');
      var dots = boks ? boks.querySelector('[data-employee-dots]') : null;
      var current = 0;
      var timer = null;

      function goTo(i) {
        current = ((i % antal) + antal) % antal;
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        if (dots) {
          var knapper = dots.children;
          for (var n = 0; n < knapper.length; n++) {
            knapper[n].setAttribute('aria-selected', n === current ? 'true' : 'false');
          }
        }
      }

      if (dots) {
        for (var i = 0; i < antal; i++) {
          (function (index) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('role', 'tab');
            b.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
            var navn = kort[index].querySelector('.ansatte-card__name');
            b.setAttribute('aria-label', navn ? navn.textContent.trim() : 'Kontaktperson ' + (index + 1));
            b.addEventListener('click', function () {
              stop();
              goTo(index);
            });
            dots.appendChild(b);
          })(i);
        }
      }

      function next() { goTo(current + 1); }
      function start() {
        if (slider.dataset.autoplay !== 'true') return;
        var sek = parseInt(slider.dataset.speed, 10) || 5;
        stop();
        timer = setInterval(next, sek * 1000);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);

      goTo(0);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    }

    function bootSliders() {
      document.querySelectorAll('[data-employee-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootSliders);
    } else {
      bootSliders();
    }
    document.addEventListener('shopify:section:load', bootSliders);
  })();

  (function () {
    function init(form) {
      if (form.dataset.serviceRequestBound === '1') return;
      form.dataset.serviceRequestBound = '1';

      var statusEl = form.querySelector('[data-service-request-status]');
      var submitBtn = form.querySelector('button[type="submit"]');

      function show(state, message) {
        if (!statusEl) return;
        statusEl.hidden = false;
        statusEl.setAttribute('data-state', state);
        statusEl.textContent = message;
      }

      function value(name) {
        var el = form.querySelector('[name="' + name + '"]');
        return el && typeof el.value === 'string' ? el.value.trim() : '';
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var name = value('name');
        var email = value('email');
        var nameEl = form.querySelector('[name="name"]');
        var emailEl = form.querySelector('[name="email"]');
        if (nameEl) nameEl.setAttribute('aria-invalid', name ? 'false' : 'true');
        var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (emailEl) emailEl.setAttribute('aria-invalid', emailOk ? 'false' : 'true');

        if (!name || !emailOk) {
          show('error', 'Udfyld navn og en gyldig e-mail, så vi kan svare dig.');
          (name ? emailEl : nameEl).focus();
          return;
        }

        var payload = {
          requestType: value('requestType'),
          machine: {
            brand: value('brand'),
            model: value('model'),
            serialNumber: value('serialNumber'),
            hours: value('hours')
          },
          customer: {
            name: name,
            email: email,
            phone: value('phone'),
            company: value('company'),
            location: value('location'),
            preferredDate: value('preferredDate'),
            message: value('message')
          },
          company: value('hp_company')
        };

        if (submitBtn) submitBtn.disabled = true;
        show('pending', 'Sender …');

        // ITG-1742: stabile fejlkoder fra serveren mappes til dansk kundetekst
        // her — den rå årsag (fx "ZeptoMail 500: …") vises ALDRIG for kunden,
        // men logges til konsollen sammen med sagsnummeret, så fejlsøgning ikke
        // kræver at gætte eller grave i netværksfanen.
        var CODE_MESSAGES = {
          missing_fields: 'Udfyld navn og en gyldig e-mail, så vi kan svare dig.',
          invalid_email: 'E-mailadressen ser ikke rigtig ud. Tjek den og prøv igen.'
        };

        // Sagsnummer = UUID'ens første 8 tegn, store bogstaver — samme
        // algoritme som admin-siden (app.configurators.service-log.tsx) i
        // Ibemortensenkonfigurator-repoet, så et opringende sagsnummer kan
        // slås op der.
        function shortRef(requestId) {
          return typeof requestId === 'string' && requestId.length >= 8
            ? requestId.slice(0, 8).toUpperCase()
            : null;
        }

        fetch(form.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            var data = result.data || {};

            // Ægte succes er KUN delivered:true — en 200 med delivered:false
            // (manglende modtager, ingen mailudbyder, fejlet afsendelse) er
            // IKKE succes, selvom body.ok kan være true. Se ITG-1741/ITG-550.
            if (result.ok && data.delivered === true) {
              show('success', form.dataset.success);
              form.reset();
              if (submitBtn) submitBtn.disabled = false;
              return;
            }

            // Honeypot-svaret fra serveren ser bevidst uskadeligt ud for en
            // bot (den skal tro den slap igennem) — vis stille succes, ingen
            // fejlbesked, ingen konsollog.
            if (data.reason === 'spam') {
              show('success', form.dataset.success);
              form.reset();
              if (submitBtn) submitBtn.disabled = false;
              return;
            }

            var code = typeof data.code === 'string' ? data.code : null;
            var ref = shortRef(data.requestId);
            console.warn('[service-request]', code || 'unknown', data.requestId || null);

            var message = (code && CODE_MESSAGES[code]) || form.dataset.error;
            if (ref) message += ' (Sagsnr. ' + ref + ')';
            show('error', message);
            if (submitBtn) submitBtn.disabled = false;
          })
          .catch(function (err) {
            console.warn('[service-request]', 'network_error', null, err);
            show('error', form.dataset.error);
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }

    function boot() {
      var forms = document.querySelectorAll('[data-service-request-form]');
      for (var i = 0; i < forms.length; i++) init(forms[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // Sektionen kan gen-renderes i Customize uden sidegenindlæsning.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
